(function() {
  var SppHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SppHandler = App.loadClass('grower::handlers/placement/SppHandler');

  exports.MyFarmsSPPHandler = (function(superClass) {
    extend(MyFarmsSPPHandler, superClass);

    function MyFarmsSPPHandler() {
      this.customPlantingPlan = bind(this.customPlantingPlan, this);
      return MyFarmsSPPHandler.__super__.constructor.apply(this, arguments);
    }

    MyFarmsSPPHandler.prototype.customPlantingPlan = function(field_id, plan, notes_obj) {};

    return MyFarmsSPPHandler;

  })(SppHandler);

}).call(this);
